import type { Channel, ProductType, Quote } from "@/api_client";
import { matchProductType } from "@/utils/productUtils";

import { getProductName } from "../../utils/productName";
import type { ProductInfo } from "../types/types";
import { getAgpId } from "./agpId";

const getProductInfoEntryPage = (
  productType: ProductType,
  channel: Channel,
): ProductInfo => {
  return {
    currencyCode: "EUR",
    id: getAgpId(productType, channel),
    productName: {
      localName: getLocalName(productType),
      localSubName: undefined,
      name: getProductName(productType),
      subName: undefined,
    },
  };
};

const getProductInfo = (product: Quote, channel: Channel): ProductInfo => {
  return {
    productName: {
      localName: getLocalName(product.productType),
      localSubName: undefined,
      name: getProductName(product?.productType),
      subName: undefined,
    },
    id: getAgpId(product.productType, channel),
    currencyCode: "EUR",
  };
};

const getLocalName = (productType: ProductType | undefined): string =>
  matchProductType(productType, {
    travel: "Matka",
    householder: "Irtaimisto",
    baby: "Vauva",
    car: "Car",
    income: "",
    sport: "",
    child: "Lapsi",
    van: "Van",
    cat: "Kissa",
    dog: "Koira",
    camper: "Camper",
    "": "",
  });

export default {
  getProductInfoEntryPage,
  getProductInfo,
};
